import React from 'react';
import styled from 'styled-components';

import Title2 from '@twicapp/ui/components/Title2';

const SideBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const SideBarHeader = styled(Title2)`
  padding-left: 15px;
  padding-bottom: 5px;
`;

const SideNavigationBar = ({ header, children }: $TSFixMe) => (
  <SideBarContainer>
    <SideBarHeader>{header}</SideBarHeader>
    {children}
  </SideBarContainer>
);

export default SideNavigationBar;
